import {
  QuotesHomeListProps,
  QuotesPreviewProps,
  QuotesTravelAgentProps,
} from '@arriere/types/Quotes.types'
import { fetchTemplates } from '@utils/fetchApi'

export const getRegularQuotesEmail = (body: QuotesPreviewProps) => {
  return fetchTemplates({ body, url: 'Quotes' })
}

export const getTravelAgentQuotesEmail = (body?: QuotesTravelAgentProps) => {
  return fetchTemplates({ body, url: 'QuotesTravelAgent' })
}

export const getHomesListQuotesEmail = (body?: QuotesHomeListProps) => {
  return fetchTemplates({ body, url: 'QuotesHomeList' })
}
